export const blockIconsContentShield = (
	<span className='material-symbols-outlined'>shield</span>
);
